<template>
  <div class="add-partner container-style">
    <el-card class="searchCard" shadow="never">
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        v-loading="formLoading"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item label="姓名" prop="userName">
              <el-input v-model="ruleForm.userName" placeholder="请输入员工姓名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="角色" prop="userRole">
              <el-select
                v-model="ruleForm.userRole"
                filterable
                placeholder="请选择角色"
                style="width:100%"
              >
                <el-option
                  v-for="item in roleOptions"
                  :key="item.roleId"
                  :label="item.roleName"
                  :value="item.roleId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="员工编号" prop="userId">
              <el-input v-model="ruleForm.userId" placeholder="请输入员工编号"  :disabled="isEdit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="员工账号" prop="userAccount">
              <el-input v-model="ruleForm.userAccount" placeholder="请输入员工账号"  :disabled="isEdit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="关联店铺" prop="relatedShopId">
              <el-select
                :disabled="isEdit"
                v-model="ruleForm.relatedShopId"
                filterable
                placeholder="请选择"
                style="width:100%"
              >
                <el-option
                  v-for="item in shopOptions"
                  :key="item.relatedShopId"
                  :label="item.relatedShopName"
                  :value="item.relatedShopId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10" v-if="isEdit">
            <el-form-item label="状态" prop="userStatus">
              <el-radio-group v-model="ruleForm.userStatus">
                <el-radio :label="1">
                  启用
                </el-radio>
                <el-radio :label="2">
                  停用
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="20" v-else style="margin-bottom:50px;margin-top:20px">
            员工编号、账号若未输入，系统可自动生成。账号密码会发送到员工手机号。
          </el-col>
        </el-row>
         <el-form-item style="text-align:center;margin:50px 0">
          <el-button @click="handleGoout" style="width:120px;margin-right:50px">退出</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')" style="width:120px">
            确定
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getUserAccountDetail, getAllRoleInfo, getAllRelateShopInfo, editUserAccount } from '@/api/userAccount'
import {
  checkName,
  checkPhone,
  checkAccount,
  checkUserID
} from '@/utils/validate'
export default {
  data () {
    return {
      formLoading: false,
      isEdit: false, // 判断是新建还是编辑状态
      roleOptions: [],
      shopOptions: [],
      ruleForm: {
        userName: '',
        phone: '',
        userRole: '',
        userId: '',
        userAccount: '',
        relatedShopId: '',
        userStatus: ''
      },
      rules: {
        userName: [{ required: true, validator: checkName, trigger: 'change' }],
        phone: [{ required: true, validator: checkPhone, trigger: 'change' }],
        userRole: [{ required: true, message: '请选择角色', trigger: 'change' }],
        userId: [
          // { required: true, message: '请输入员工编号', trigger: 'change' },
          { validator: checkUserID, trigger: 'change' }
        ],
        userAccount: [
          // { required: true, message: '请输入员工共账号', trigger: 'change' },
          { validator: checkAccount, trigger: 'change' }
        ],
        relatedShopId: [{ required: true, message: '请选择关联店铺', trigger: 'change' }],
        userStatus: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  mounted () {
    const { id } = this.$route.query
    if (id) {
      this.isEdit = true
      this.getUserAccountDetail(id)
      this.handleUPdateVisitedView('编辑员工账号')
    } else {
      this.isEdit = false
      this.handleUPdateVisitedView('新增员工账号')
      this.getAllRoleInfo()
      this.getAllRelateShopInfo()
    }
  },
  methods: {
    handleUPdateVisitedView (title) {
      this.$route.meta.title = title
      document.title = title
      this.$store.dispatch('updateVisitedViews', this.$route)
    },
    PrefixInteger (num, length) {
      return (Array(length).join('0') + num).slice(-length)
    },
    getUserAccountDetail (id) {
      this.formLoading = true
      getUserAccountDetail({ id }).then(response => {
        this.formLoading = false
        if (+response.error_code === 0) {
          this.ruleForm = Object.assign({}, this.ruleForm, response.data.account)
          this.ruleForm.userId = this.PrefixInteger(this.ruleForm.userId, 5)
          this.roleOptions = response.data.zzgRoleList
          this.shopOptions = response.data.relateShopInfoList
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    getAllRoleInfo () {
      getAllRoleInfo().then(response => {
        if (+response.error_code === 0) {
          this.roleOptions = response.data
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    getAllRelateShopInfo () {
      getAllRelateShopInfo().then(response => {
        if (+response.error_code === 0) {
          this.shopOptions = response.data
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    handleGoout () {
      this.$router.push({ path: '/empManage/empManageInfoSet/account-management' })
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const params = Object.assign({}, this.ruleForm)
          editUserAccount(params).then(data => {
            this.sendMsgLoading = false
            if (+data.error_code === 0) {
              if (!this.isEdit) {
                this.$message.success('新建成功')
              } else {
                this.$message.success('编辑成功')
              }
              const id = data.data.id
              console.log('data.data.account.id: ', data.data.id)
              this.getUserAccountDetail(id)
            } else {
              this.$message.error(data.error_msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped></style>
